module.exports = __webpack_public_path__ + "img/ic_save_rose.0cd883a6.svg";